import { QueryFilterParams } from '../hooks';
import { getLocalStorageOrDefault } from './commonUtils';
import { JsonApiData, JsonApiObject, JsonApiQueryParameters } from './jsonApi';

export interface IEntity {
  id: string;
  _id?: string; // todo: verify the need for this one
  name?: string;
  created_at?: string; // todo: remove
  removed_at?: string; // todo: remove
  modified_at?: string; // todo: remove
  createdAt?: string;
  deletedAt?: string;
  updatedAt?: string;
}

export const prepareHeaders = (headers: Headers) => {
  const token = getLocalStorageOrDefault('access_token');

  // If we have a token set in state, let's assume that we should be passing it.
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return headers;
};

export function transformResponseFromJsonApi<T>(response: JsonApiData<T>): {
  ids: string[];
  total: number;
  values: T[];
} {
  let data, values;
  if (Array.isArray(response.data)) {
    data = response.data as JsonApiObject<T>[];
    values = data.map(({ attributes, id }) => ({ ...attributes, id }));
  } else {
    data = response.data as JsonApiObject<T>;
    values = [{ ...data.attributes, id: data.id }];
  }

  return {
    values,
    total: response.meta?.total ?? values.length,
    ids: response.meta?.ids ?? [],
  };
}
export const formatRequestForJsonApi = (
  payload: any,
  method: 'POST' | 'PATCH' | 'DELETE',
  url = '',
) => {
  const { id, ...payloadNoId } = payload;
  const body = { data: { id: id ?? '', attributes: payloadNoId } };
  return { url, body, method };
};

export const formatQueryForJsonApi = (params: JsonApiQueryParameters, url?: string) => {
  let queryParams = url || '';
  if (!params) {
    return queryParams;
  } else {
    queryParams += '/?';
  }

  const { page, sort, filter } = params;

  if (page) {
    queryParams += `page[offset]=${page.limit * (page.offset - 1)}&page[limit]=${page.limit}&`;
  }
  if (sort && sort.length > 0) {
    queryParams += `sort=${sort.join(',')}&`;
  }

  // Careful here, value should not be undefined but can be a boolean.
  if (filter && filter.length > 0) {
    queryParams += filter
      .map((f) => (f.value !== undefined ? `filter[${f.name}]=${f.value}` : ''))
      .join('&');
  }

  return queryParams;
};

export const addSearchFilter = (
  searchValue = '',
  filters: QueryFilterParams[],
): QueryFilterParams[] => {
  const newFilters = [...filters];
  const searchFilter = newFilters.find((f) => f.name === 'search');
  if (searchFilter) {
    searchFilter.value = searchValue;
  } else if (!searchFilter) {
    newFilters.push({ name: 'search', value: searchValue });
  }
  return newFilters;
};
